module.exports = __webpack_public_path__ + "img/prev-compare-b1.66569193.webp";